<template>
  <div class="finished">
    <img src="../../assets/images/icon10.png" alt="">
    <p class="aColor font-blod">信息已完善</p>
    <ul>
      <li>银行卡限额情况</li>
      <li>单笔充值限额：<span class="rColor">{{deal}}</span> 元</li>
      <li>单日充值限额：<span class="rColor">{{day}}</span> 元</li>
    </ul>
    <el-button type="normal margin-t30" @click="$router.push({name:'myAssets'})">去交易</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      deal: '--',
      day: '--'
    }
  },
  mounted () {
    this.getBank()
  },
  methods: {
    getBank () {
      this.$http.post(this.$apiPath.myBankList, {
        custno: this.$commonJs.getCookie('u_custno1'),
      }).then(res => {
        if (res.data.code == "200" && res.data.success) {
          const result = res.data.data
          if (result.length > 0) {
            this.deal = result[0].singledeallimit
            this.day = result[0].singledaylimit
          }
        }
      }).catch(err => { })
    }
  }
}
</script>

<style lang="less" scoped>
.finished {
  width: 200px;
  margin: 0 auto;
  padding: 100px 0;
  text-align: center;
  p {
    margin: 15px 0 30px;
    font-size: 18px;
  }
  li {
    text-align: left;
    line-height: 25px;
    white-space: nowrap;
  }
}
</style>